export const CURRENCY_OPTIONS = [
  { code: 'USD', label: 'USD ($)' },
  { code: 'EUR', label: 'EUR (€)' },
  { code: 'DZD', label: 'DZD (Algerian Dinar)' },
];

const LOCALE_BY_CURRENCY = {
  USD: 'en-US',
  EUR: 'fr-FR',
  DZD: 'fr-DZ',
};

/**
 * Format a price with its currency. Falls back to a plain "<code> <amount>"
 * string if Intl doesn't recognize the currency in this environment.
 */
export function formatPrice(price, currency = 'USD') {
  const amount = Number(price) || 0;
  try {
    return new Intl.NumberFormat(LOCALE_BY_CURRENCY[currency] || 'en-US', {
      style: 'currency',
      currency: currency || 'USD',
      minimumFractionDigits: 2,
    }).format(amount);
  } catch (e) {
    return `${amount.toFixed(2)} ${currency}`;
  }
}
